import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { LANG } from "./domain/i18n";

i18n.use(LanguageDetector).init({
  fallbackLng: LANG.PORTUGUESE,
  debug:
    process.env.NODE_ENV !== "test" && process.env.NODE_ENV !== "production",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
